import Dialog from '../../../../common/dialog';
import l from '../../../../../lang';
import { useTransactions } from '../../../../../store/transactions';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './styles.scss';

const ExportEmailModal = () => {
  const { export: { emailSent }, dismissExportEmailModal } = useTransactions();

  return (
    <div className="export_email_modal">
      <Dialog
        open={emailSent}
        dividers={false}
        title={<span>{l('exportTransactions.emailModal.title')}</span>}
        titleCenter
        paperClassName="export_email_modal__dialog-paper"
        type="sm"
        handleClose={dismissExportEmailModal}
        body={
          <div className="export_email_modal__content">
            <div className="export_email_modal__success-icon" aria-hidden>
              <CheckCircleOutlineIcon />
            </div>
            <p>{l('exportTransactions.emailModal.message')}</p>
          </div>
        }
        footer={<div className="export_email_modal__footer" />}
      />
    </div>
  );
};

export default ExportEmailModal;
